export const SESSION_LENGTH_OPTIONS = [
  { key: 'fixed-5', questionCountMode: 'fixed', questionCount: 5, label: '5 questions' },
  { key: 'fixed-10', questionCountMode: 'fixed', questionCount: 10, label: '10 questions' },
  { key: 'fixed-15', questionCountMode: 'fixed', questionCount: 15, label: '15 questions' },
  {
    key: 'endless',
    questionCountMode: 'endless',
    questionCount: null,
    label: 'Endless',
    helperText: 'Continue until you decide to stop.',
  },
];

export const DEFAULT_SESSION_LENGTH = {
  questionCountMode: 'fixed',
  questionCount: 10,
};

export function normalizeSessionLengthSelection(selection = {}) {
  const mode = selection.questionCountMode === 'endless' ? 'endless' : 'fixed';
  if (mode === 'endless') {
    return {
      questionCountMode: 'endless',
      questionCount: null,
    };
  }
  const count = [5, 10, 15].includes(Number(selection.questionCount))
    ? Number(selection.questionCount)
    : 10;
  return {
    questionCountMode: 'fixed',
    questionCount: count,
  };
}

export function buildSessionLengthPayload(selection = {}) {
  const normalized = normalizeSessionLengthSelection(selection);
  if (normalized.questionCountMode === 'endless') {
    return { question_count_mode: 'endless' };
  }
  return {
    question_count_mode: 'fixed',
    question_count: normalized.questionCount,
  };
}
